/**
 * @generated SignedSource<<ca313e1730205ddffbd31fa379cae58a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentHeader_content$data = {
  readonly contentTypesHeader: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentTypesHeader_content">;
  };
  readonly editContentButton: {
    readonly " $fragmentSpreads": FragmentRefs<"EditContentButton_content">;
  };
  readonly fabricEditorEligibility?: {
    readonly " $fragmentSpreads": FragmentRefs<"useFabricEligibilityMigrationQuery_content">;
  } | null;
  readonly id: string | null;
  readonly metadata: {
    readonly frontend: {
      readonly fabricEditorSupported: boolean | null;
    } | null;
    readonly lastModifiedDate: string | null;
  };
  readonly shareAndRestrictButtonData?: {
    readonly " $fragmentSpreads": FragmentRefs<"useShareAndRestrictButtonData_content">;
  } | null;
  readonly smartCreateFeedback?: {
    readonly " $fragmentSpreads": FragmentRefs<"SmartCreateFeedbackBanner_content">;
  } | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "ContentHeader_content";
};
export type ContentHeader_content$key = {
  readonly " $data"?: ContentHeader_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAccessButton"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeFabricEditorEligibility"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeSmartCreateFeedback"
    }
  ],
  "kind": "Fragment",
  "name": "ContentHeader_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
          "kind": "LinkedField",
          "name": "frontend",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fabricEditorSupported"
            }
          ]
        }
      ]
    },
    {
      "condition": "includeFabricEditorEligibility",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useFabricEligibilityMigrationQuery_content"
              }
            ],
            "type": "Content"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "fabricEditorEligibility"
        }
      ]
    },
    {
      "condition": "includeSmartCreateFeedback",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SmartCreateFeedbackBanner_content"
              }
            ],
            "type": "Content"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "smartCreateFeedback"
        }
      ]
    },
    {
      "fragment": {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentTypesHeader_content"
          }
        ],
        "type": "Content"
      },
      "kind": "AliasedInlineFragmentSpread",
      "name": "contentTypesHeader"
    },
    {
      "fragment": {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EditContentButton_content"
          }
        ],
        "type": "Content"
      },
      "kind": "AliasedInlineFragmentSpread",
      "name": "editContentButton"
    },
    {
      "condition": "includeAccessButton",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useShareAndRestrictButtonData_content"
              }
            ],
            "type": "Content"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "shareAndRestrictButtonData"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "5f96edd5ad0b25103dfbe0765b7e9599";

export default node;
